module.exports = __webpack_public_path__ + "static/tablet-footer-age-b9488531f95c61f28f5b4a01bd76d250.jpg";